import { render, staticRenderFns } from "./FacilityDashboard.vue?vue&type=template&id=c1edd0e6"
import script from "./FacilityDashboard.vue?vue&type=script&lang=js"
export * from "./FacilityDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports